import { Component, ElementRef, Inject, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogBase, OrderCustomerInfo, OrderCustomerModel, ChecklistTerminationModel } from 't4core';

@Component({
    selector: 'why-not-terminated',
  templateUrl: './ChecklistTerminationDialog.html',
  styleUrls: ['./ChecklistTerminationDialog.css']
})
export class ChecklistTerminationDialog extends DialogBase implements OnInit {
  public contractId: number;
  public checklist: ChecklistTerminationModel;
  public isLoading: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<ChecklistTerminationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("ChecklistTerminationDialog");
    this.contractId = data.contractId;
  }

  public async ngOnInit() {
    this.isLoading = true;
    var result = await this.Api.get<ChecklistTerminationModel>("/TurboOrder/ChecklistTermination", { contractId: this.contractId });
    this.checklist = result;
    this.isLoading = false;
  }

  public static async open(dialog: MatDialog, contractId: number) {
    var dlg = dialog.open(ChecklistTerminationDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      width: "500px",
      data: {
        contractId: contractId
      }
    });
  }
}
